import { navItems, siteName } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-800 text-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-foreground-950">
                <i className="ri-movie-2-line text-lg" />
              </span>
              <span className="font-heading text-lg font-bold text-background-50">{siteName}</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-200/80">
              围绕师兄系列、同门电影与大师兄电影的人物 IP 信息整理站，并补充甄子丹的动作方向，以及喜剧片与剧情片两条类型线索。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">本页导航</h3>
            <ul className="mt-4 space-y-2">
              {navItems.map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    className="text-sm text-background-200/80 transition-colors hover:text-accent-300"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-bold text-background-50">说明</h3>
            <p className="mt-4 text-sm leading-relaxed text-background-200/80">
              本站内容为一般性信息整理，不提供影片播放或下载。涉及具体作品的信息，请以官方发布的资料为准。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-200/70">
            © 2026 {siteName} · 单页信息整理
          </p>
          <p className="text-xs text-background-200/70">
            内容仅用于了解与对照，不构成任何观看指引
          </p>
        </div>
      </div>
    </footer>
  );
}